module.exports = "/assets/7aa03dd7627e2a2c86f27876eb0966e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/RO.png
// module id = 1793
// module chunks = 0